import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '../../constants';

/**
 * Formats a lead time for display, always with its unit: "8 to 9 weeks", "1 week".
 *
 * api-v2 returns a quote line's lead time WITHOUT a unit ("8 to 9", "1"), while the
 * product-level value carries one ("8 to 9 weeks"). Every screen goes through this so the
 * two read the same. Text values ("In Stock", "TBC", "Limited Sale Stock Only") pass through.
 */
export function formatProductLeadTime(leadTime: any): any {
    if (leadTime === null || leadTime === undefined || leadTime === '') return leadTime;
    const value = String(leadTime).trim();

    if (Constants.FILTER_AVAILABLE_STRING.some(element => value.includes(element))) {
        return Constants.LEAD_TIME_IN_STOCK;
    }
    if (Constants.FILTER_LOW_AVAILABLE_STRING.some(element => value.includes(element))) {
        return Constants.LEAD_TIME_LOW_STOCK;
    }
    // Drop any unit already present ("8 Weeks to 9 weeks", "Limited Sale Stock Only weeks")
    // and add one back only to a number of weeks.
    const text = value.replace(/\bweeks?\b/gi, '').replace(/\s+/g, ' ').trim();
    if (!/\d/.test(text)) return text;
    return `${text} ${text === '1' ? 'week' : 'weeks'}`;
}

@Pipe({
  standalone: false,
    name: 'productLeadTime'
})
export class ProductLeadTimePipe implements PipeTransform {

    transform(leadTime: any): unknown {
        return formatProductLeadTime(leadTime);
    }
}
